import store from '@/store'
import * as apiPayment from '@/api/payment'
import { getLCRequestName } from '@/logic/common/CommonPaymentMethod'

const payment = {
  namespaced: true,
  state: {
    // 選択中の支払い方法ID
    // (支払い方法コンポーネント(ContactPaymentMethod)で選択した支払い方法を保持)
    // IDは、以下の「agreements.payment_classification」の値を設定
    // 1=クレジット自動決済（一括払い） 2=クレジット自動決済（分割払い）
    // 3=口座振替 6=振替・コンビニ  7=銀行振込
    paymentClassification: 0,

    // 審査状態フラグ(初期表示はfalseにする。
    // 審査中の場合、APIの結果を取得するまで「追加購入」「ライセンス購入」が初期表示時の一瞬アクティブになるが、
    // APIの通信失敗で、ボタンが押せなくなるリスクを考えると、デフォルトは押せた方が良い。
    // もし次の画面に行けたとしても、最終的な実行時のAPIの処理で登録できない対応はしているので問題無し)
    isUnderExam: false,

    // 申請情報取得API(SN-010)の「2」の状態コード(request)の値
    // 状態コード (1:受付 2:審査中 3:有効 4:停止 8:却下 9:解約 97:契約削除 98:合併 99:退会)
    request: 0,

    // 同月に今と異なる決済方法での購入があるかどうか。
    // あった場合はこのパラメタはtrueとし、その際購入不可となる。
    boughtThisMonthDifPayment: false
  },
  getters: {
  },
  mutations: {
    setPaymentClassification(state, value) {
      state.paymentClassification = value
    },
    setUnderExam(state, isUnderExam) {
      state.isUnderExam = isUnderExam
    },
    setRequest(state, request) {
      state.request = request
    },
    setDifPayment(state, boughtThisMonthDifPayment) {
      state.boughtThisMonthDifPayment = boughtThisMonthDifPayment
    }
  },
  actions: {
    // 選択中の支払いIDを設定
    setPaymentClassification({ commit }, value) {
      commit('setPaymentClassification', value)
    },

    // 購入可能かのチェック（審査中状態かどうか、同月異なる決済方法での購入済みか）
    checkAvailablePurchase({ commit }) {

      // 支払い方法取得APIをコール
      const params = {
      }
      apiPayment.fetchPaymentMethod(params)
        .then(response => {
          if (response) {

            const { data } = response
            const status = data.status

            if (status === 0) {
              // 同月の決済方法と現在の決済方法が異なっているかどうかの判定
              commit('setDifPayment', data.dif_payment_flag)
              const authorization = data.authorization

              // 申請情報取得APIは、支払い方法取得APIのレスポンスのauthorizationの値がtrueの場合のみしか
              // リクエストしてはならない
              if (authorization) {

                // 申請情報取得APIをコール
                const identificationCode = store.state.profile.identification_code
                const params = {
                  identification_code: identificationCode // 契約識別コード
                }
                apiPayment.fetchApplicationInfo(params)
                  .then(response => {
                    if (response) {
                      const { data } = response

                      // リーガルコネクションの申請状況
                      const lcResult = data['2']

                      // 状態コード (1:受付 2:審査中 3:有効 4:停止 8:却下 9:解約 97:契約削除 98:合併 99:退会)
                      // ※審査中は「1:受付 or 2:審査中」、審査完了は「3:有効」である
                      const lcRequest = parseInt(lcResult.request)

                      // 状態コードをストアに保持
                      store.dispatch('payment/setRequest', lcRequest)

                      // 状態コードに対する状態の名称を取得
                      const name = getLCRequestName(lcRequest)

                      // 審査中フラグ
                      const isUnderExam = (name === 'under_exam')

                      commit('setUnderExam', isUnderExam)
                    }
                  })
              }
            }
          }
        })

    },

    // 状態コードを設定
    setRequest({ commit }, value) {
      commit('setRequest', value)
    }

  }
}

export default payment
